import { create } from 'zustand';

interface OverlayMediaState {
  mediaId: string | undefined;
  setMediaId: (id: string) => void;
  clear: () => void;
}

const useOverlayMediaStore = create<OverlayMediaState>((set) => ({
  mediaId: undefined,
  setMediaId: (id) => set({ mediaId: id }),
  clear: () => set({ mediaId: undefined }),
}));

export default useOverlayMediaStore;
